import { Injectable } from '@angular/core';
import { morseCode, morseDecode } from '../../assets/morse';

@Injectable()
export class CryptoService {

  constructor() { }

  morseCode = morseCode;
  morseDecode = morseDecode;


  createArray(size: number): number[] {
    return Array.from(Array(size).keys());
  }

  fromCharCode(i: number): string {
    return String.fromCharCode(i);
  }


  /**
   * returns the encoded text
   * @param method - method to encode
   * @param key - key for method
   * @param text - text
   */
  encode(method: string, key: any, text: string) {
    switch (method) {
      case "caesar": return this.encodeCaeser(key, text);
      case "polybius": return this.encodePolybius(text);
      case "skytale": return this.encodeSkytale(key, text);
      case "monoalphabetic": return this.encodeMonoalphabetic(key, text);
      case "vignere": return this.encodeVignere(key, text);
      case "vignereLetters": return this.encodeVignere(key, text);
      case "vignereDigits": return this.encodeVignere(key, text);
      case "atbash": return this.encodeAtbash(text);
      case "morse": return this.encodeMorse(text);
      case "pigpen": return text;
    }
  }

  /**
   * returns the decoded text
   * @param method - method to encode
   * @param key - key for method
   * @param text - text
   */
  decode(method: string, key: any, text: string) {
    switch (method) {
      case "caesar": return this.decodeCaeser(key, text);
      case "polybius": return this.decodePolybius(text);
      case "skytale": return this.decodeSkytale(key, text);
      case "monoalphabetic": return this.decodeMonoalphabetic(key, text);
      case "vignere": return this.decodeVignere(key, text);
      case "vignereLetters": return this.decodeVignere(key, text);
      case "vignereDigits": return this.decodeVignere(key, text);
      case "atbash": return this.decodeAtbash(text);
      case "morse": return this.decodeMorse(text);
      case "pigpen": return text;
    }
  }



  encodeCaeser(key: number, text: string): string {
    if(!key && key!= 0){
      return "";
    }
    return text.split("").map(v => v == " " ? (v.charCodeAt(0) - 65) : (v.charCodeAt(0) - 65 + key) % 26).map(v => String.fromCharCode(v + 65)).join("");
  }

  decodeCaeser(key: number, text: string): string {
    if(!key && key!= 0){
      return "";
    }
    return text.split("").map(v => v == " " ? (v.charCodeAt(0) - 65) : (v.charCodeAt(0) - 65 - key + 26) % 26).map(v => String.fromCharCode(v + 65)).join("");
  }

  encodePolybius(text: string): string {
    let result: any[] = text.split("");
    result = result.map(v => v === " " ? " " : v.charCodeAt(0) - 65);
    result = result.map(v => v === " " ? " " : (v >= 9 ? v - 1 : v));
    result = result.map(v => v === " " ? " " : (v >= 20 ? v - 1 : v));
    result = result.map(v => v === " " ? " " : [v, Math.floor(v / 5)]);
    result = result.map(v => v === " " ? " " : [v[1] + 1, v[0] - 5 * v[1] + 1]);
    result = result.map(v => v === " " ? [" "] : [v[0].toString(), v[1].toString()]);
    let resultStr: string = result.map(v => v.join("")).join("");
    return resultStr;
  }

  decodePolybius(text: string): string {
    let result: any[] = [];
    while (text.length > 0) {
      if (text.charAt(0) === " ") {
        result.push(" ");
        text = text.slice(1, text.length);
      } else {
        result.push([text.charAt(0), text.charAt(1)]);
        text = text.slice(2, text.length);
      }
    }
    result = result.map(v => v === " " ? " " : 5 * (+v[0] - 1) + (+v[1]) - 1);
    result = result.map(v => v === " " ? " " : (v >= 9 ? v + 1 : v));
    result = result.map(v => v === " " ? " " : (v > 20 ? v + 1 : v));
    result = result.map(v => v === " " ? " " : String.fromCharCode(v + 65));
    return result.join("");
  }

  decodeSkytale(key: number, text: string): string {
    if (!key) {
      return "";
    }
    let result = "";
    let position = 0;
    for (let i = 0; i < key; i++) {
      position = i;
      while (position < text.length) {
        result = result.concat(text.charAt(position));
        position += key;
      }
    }
    result = result.replace(/-/gi, " ");
    return result;
  }

  encodeSkytale(key, text: string): string {
    if (!key) {
      return "";
    }
    let length = Math.ceil(text.length / key);
    let result = "";
    let position = 0;
    for (let i = 0; i < length; i++) {
      position = i;
      while (position < text.length) {
        result = result.concat(text.charAt(position));
        position += length;
      }
      while (position < length * key) {
        result = result.concat(" ");
        position += length;
      }
    }
    return result;

  }

  encodeMonoalphabetic(key: string, text: string): string {
    if(!key){
      return "";
    }
    return text.split("").map(v => v === " " ? " " : key.charAt(v.charCodeAt(0) - 65)).join("");
  }

  decodeMonoalphabetic(key: string, text: string): string {
    if(!key){
      return "";
    }
    return text.split("").map(v => v === "-" || v === " " ? " " : String.fromCharCode(key.indexOf(v) + 65)).join("");
  }

  encodeVignere(key: string, text: string): string {
    if(!key || !text){
      return undefined;
    }
    let withLetters: boolean;
    if (key.includes('0') || key.includes('1')) {
      withLetters = false;
    } else {
      withLetters = true;
    }
    if (withLetters) {
      let nonEmptyIndex = [];
      let index = 0;
      for (let c of text) {
        if (c == " ") {
          nonEmptyIndex.push(-1);
        } else {
          nonEmptyIndex.push(index);
          index++;
        }
      }
      return text.split("").map((v, i) => v===" "?" ":this.encodeCaeser(key.charCodeAt(nonEmptyIndex[i] % key.length) - "A".charCodeAt(0), v)).join("");
    } else {
      return text.split("").map((v,i)=>(v==key.charAt(i%key.length)?"0":"1")).join("");
    }
  }

  decodeVignere(key: string, text: string): string {
    if(!key || !text){
      return undefined;
    }
    let withLetters: boolean;
    if (key.includes('0') || key.includes('1')) {
      withLetters = false;
    } else {
      withLetters = true;
    }
    if (withLetters) {
      let nonEmptyIndex = [];
      let index = 0;
      for (let c of text) {
        if (c == " ") {
          nonEmptyIndex.push(-1);
        } else {
          nonEmptyIndex.push(index);
          index++;
        }
      }
      return text.split("").map((v, i) => v===" "?" ":this.decodeCaeser(key.charCodeAt(nonEmptyIndex[i] % key.length) - "A".charCodeAt(0), v)).join("");
    } else {
      return text.split("").map((v,i)=>(v=="0"?key.charAt(i%key.length):(1-+key.charAt(i%key.length)).toString())).join("");
    }}

  normalizeVignereKeys(key:string, mode:string):string{
    if (mode == 'digits'){
      return key.replace(/[^01]/gi, "");
    } else {
      return key.toUpperCase().replace(/[^A-Z]/gi, "");
    }
  }

  encodeAtbash(text:string):string{
    return text.split("").map(v => v===" "?" ": String.fromCharCode(25 - (v.charCodeAt(0)-65)+65)).join("");
  }

  decodeAtbash(text:string):string{
    return text.split("").map(v => v===" "?" ": String.fromCharCode(25 - (v.charCodeAt(0)-65)+65)).join("");
  }

  encodeMorse(text:string){
    if(!text){
      return " ";
    }
    return text.split("").map(v => this.morseCode[v.toLowerCase()]).join("|");
  }

  decodeMorse(text:string){
    if(!text){
      return " ";
    }
    return text.split("|").map(v => this.morseDecode[v].toUpperCase()).join("");
  }

  normalizeText(text): string {
    return text.replace(/[^a-z ]/gi, ' ').toUpperCase().replace(/\s+/g, ' ');
  }

  computefrequencies(frequency: any[], bigrams: any[], trigrams: any[], text: string) {

    let length = text.replace(/ /gi, "").length;
    if (!text) {
      return;
    }

    frequency.length = 0;
    for (let a of this.createArray(26)) {
      frequency.push({ key: this.fromCharCode(a + 65), value: 0 });
    }

    for (let d of text) {
      if (d != " ") {
        frequency[d.charCodeAt(0) - 65].value++;
      }
    }
    for (let a of this.createArray(26)) {
      frequency[a].value = Math.floor(frequency[a].value / length * 1000) / 10;;
    }
    frequency.sort((a, b) => +b.value - +a.value);

    bigrams.length = 0;
    let bigramIndex = [];
    let bigramLength = 0;

    for (let i of this.createArray(text.length - 1)) {
      let mybi = text.slice(i, i + 2);
      if (mybi.includes(" ")) {
        continue;
      }
      bigramLength++;
      if (!bigramIndex.includes(mybi)) {
        bigramIndex.push(mybi);
        bigrams.push({ key: mybi, value: 0 });
      }
      bigrams[bigramIndex.indexOf(mybi)].value++;
    }
    for (let i in bigrams) {
      bigrams[i].value = Math.floor(bigrams[i].value / (bigramLength - 1) * 1000) / 10;
    }
    bigrams.sort((a, b) => +b.value - +a.value);
    trigrams.length = 0;
    let trigramIndex = []
    let trigramLength = 0;

    for (let i of this.createArray(text.length - 1)) {
      let mybi = text.slice(i, i + 3);
      if (mybi.includes(" ")) {
        continue;
      }
      trigramLength++;
      if (!trigramIndex.includes(mybi)) {
        trigramIndex.push(mybi);
        trigrams.push({ key: mybi, value: 0 });
      }
      trigrams[trigramIndex.indexOf(mybi)].value++;
    }
    for (let i in trigrams) {
      trigrams[i].value = Math.floor(trigrams[i].value / (trigramLength - 1) * 1000) / 10;
    }
    trigrams.sort((a, b) => +b.value - +a.value);

  }

 }

